"use client";
import { motion } from "framer-motion";
import React from "react";
import "./OtherPageBanner.css";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Image from "next/image";
function OtherPageBanner({
  title,
  description,
  subtitle,
  bannerWeb,
  bannerMobile,
  highlights,
}) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const scaleFadeVariant = {
    hidden: {
      opacity: 0,
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15,
      },
    },
  };
  return (
    <div className="other-page-banner-wrapper">
      <div className="care-wrapper relative section-paddinglarge">
        <div className="inner-flex main-container-fluid inner-flex-big5 ">
          <div className="flex-row section-flex">
            <div
              className="inner-flex j-c-c other-page-flex"
              style={{ gap: "0" }}
            >
              <div className="">
                <h1 className="secondary-color">{title}</h1>
              </div>
              <div className="section-title64 other-page-subline">
                <h2 className="bold-fonts">{subtitle}</h2>
              </div>
            </div>

            <div className="relative section-image">
              <Image
                src={`${bannerWeb}&w=1338&h=720&q=100`}
                alt={title}
                fill
              />

              {/* <img
                className="hide-tab-mobile"
                src={`${bannerMobile || bannerWeb}&w=640&h=800&q=100`}
                alt={title}
                className="visible-tab-mobile"
                style={{ height: "unset" }}
              /> */}
            </div>
          </div>
          <div className="inner-flex inner-flex-medium">
            {highlights && (
              <div>
                <div ref={ref} className="section-sub-text  j-c-sb flex-row">
                  <motion.div
                    variants={scaleFadeVariant}
                    className="innerflex fact-flex"
                  >
                    <div className="section-title64">
                      <h2 className="semibold-fonts">
                        {/* {inView && <CountUp start={0} end={30} duration={2} />} */}
                        <span style={{ fontWeight: "700" }}>30L+</span>
                      </h2>
                    </div>
                    <div className="section-content">
                      <p className="neue-light-fonts">
                        Sq. Ft. Area Constructed
                      </p>
                    </div>
                  </motion.div>

                  <div className="about-border2 hide-mobile-only"></div>

                  <div className="innerflex fact-flex">
                    <div className="section-title64">
                      <h2 className="semibold-fonts">
                        {/* {inView && <CountUp start={0} end={15} duration={2} />} */}
                        <span style={{ fontWeight: "700" }}>15+</span>
                      </h2>
                    </div>
                    <div
                      className="section-content"
                      style={{ width: "max-content" }}
                    >
                      <p className="neue-light-fonts">Years of Experience</p>
                    </div>
                  </div>

                  <div className="about-border2 hide-mobile-only"></div>

                  <div className="innerflex fact-flex">
                    <div className="section-title64">
                      <h2 className="semibold-fonts">
                        {/* {inView && (
                        <CountUp
                          start={0}
                          end={1000}
                          duration={2}
                          separator=","
                        />
                      )} */}
                        <span style={{ fontWeight: "700" }}>1000+</span>
                      </h2>
                    </div>
                    <div className="section-content">
                      <p className="neue-light-fonts">Units Delivered</p>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {description && (
              <div className="section-sub-text section-content22">
                <p className="regular-fonts">{description}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OtherPageBanner;
